import React, { useEffect, useState } from "react";
import { useSubheader } from "@metronic/layout";
import {
    Alert,
    Accordion,
} from "react-bootstrap";
import { InssuredData } from "@components/panels/insured-data/inssured-data";
import { HospitalData } from "@components/panels/hospital-data/hospital-data";
import { Documentation } from "@components/panels/documentation/documentation";
import { Binnacle } from "@components/panels/binnacle/binnacle";
import { MedicalOpinionData } from "@components/panels/medical-opinion-data/medical-opinion-data";
import { MedicalDataAdditional } from "@components/panels/additional-medical-data/medical-data-additional";
import { AuthLetters } from "@components/panels/auth-letter/auth-letters";
import { getBySlug } from "@services/hospitalization";
import { getLastLetterMovByCase } from "@services/letter-movements";
import { MedicAssigned } from "@components/panels/medic-assigned/medic-assigned";
import { MedicAssignationTrakingMedic } from "@components/panels/medic-assignation-tracking/medic-assignation-tracking-medic";
import { IfHasRole } from "@metronic/_helpers";
import { MedicalFees } from "@components/panels/medical-fee/medical-fees";
import CaseHeader from "@components/panels/case-header/case-header";
import CaseContext from "@contexts/case-context";
import BlockCaseContext from "@contexts/block-case-context";
import {isCaseInCorrectModule} from "@utils/check-module-status";
import {CASE_STATUS} from "@constants/case-statuses";
import {Redirect} from "react-router-dom";

const CasesCanceledDetails = (props) => {
    const subheader = useSubheader();

    const { slug } = props.match.params;

    const [caseRecord, setCaseRecord] = useState({});
    const [letterMov, setLetterMov] = useState({});
    const [totalLetters, setTotalLetters] = useState("0");
    const [, setIsFinalReject] = useState(false);
    const [shouldBlockCase, setShouldBlockCase] = useState(true);

    useEffect(() => {
        getBySlug(slug).then((response) => {
            setCaseRecord(response.data);
            setIsFinalReject(response.data.statusDictum === "Rechazo Definitivo")
            getLastLetterMovByCase(response.data.id).then((currrentLetterMov) =>
                setLetterMov(currrentLetterMov.data)
            );
        });

        subheader.setTitle("Cancelaciones");
    }, [slug]);

    if (!isCaseInCorrectModule(caseRecord, [CASE_STATUS.CANCELED, CASE_STATUS.TRACING, CASE_STATUS.MEDIC_INFORMATION, CASE_STATUS.MEDICAL_OPINION, CASE_STATUS.COST_CONTROL, CASE_STATUS.RECONSIDERATION])) {
        return <Redirect to="/error/unauthorized"/>;
    }

    return (
        <>
            <Alert
                variant="success"
                className="text-center"
                style={{ fontSize: "16px" }}
            >
                Cancelaciones
            </Alert>

            <CaseHeader caseRecord={caseRecord} />

            <BlockCaseContext.Provider value={[shouldBlockCase, setShouldBlockCase]}>
                <Accordion className="mt-5">
                    <InssuredData
                        icon="fa-search"
                        eventKey="1"
                        data={caseRecord}
                        disabledAll={true}
                        bindSubmitForm={() => {}}
                    />
                    <HospitalData
                        icon="fa-search"
                        eventKey="2"
                        data={caseRecord}
                        disabledAll={true}
                        bindSubmitForm={() => {}}
                    />
                    <MedicAssigned
                        icon="fa-search"
                        eventKey="7"
                        data={caseRecord}
                        disabledAll={true}
                        bindSubmitForm={() => {}}
                    />
                    <Documentation
                        icon= "fa-search"
                        icone="fa-pencil-alt"
                        eventKey="4"
                        data={caseRecord}
                        disabledAll={true}
                        {...props}
                    />
                    <MedicalFees
                        icon= "fa-search"
                        icone="fa-pencil-alt"
                        eventKey="5"
                        data={caseRecord}
                        hideBtnInsurance={false}
                        hideFormCreate={true}
                        disabledAll={true}
                        showForm={false}
                        {...props}
                    />
                    <AuthLetters
                        icon="fa-pencil-alt"
                        showForm={false}
                        eventKey="3"
                        data={caseRecord}
                        disabledAll={true}
                        setTotalLetters={setTotalLetters}
                        {...props}
                    />
                </Accordion>
                <Accordion className="mt-5">
                    { (IfHasRole("Admin") || IfHasRole("ADMINAXA") ) && <MedicAssignationTrakingMedic
                        icon="fa-pencil-alt"
                        eventKey="0"
                        data={caseRecord}
                        mcMovement={letterMov}
                        disabledAll={true}
                        bindSubmitForm={() => {}}
                        bindErrors={() => {}}
                    /> }
                    <MedicalOpinionData
                        icon="fa-pencil-alt"
                        setIsFinalReject={setIsFinalReject}
                        eventKey="1"
                        data={caseRecord}
                        letterMov={letterMov}
                        totalLetters={totalLetters}
                        disabledAll={true}
                        bindSubmitForm={() => {}}
                        bindErrors={() => {}}
                    />
                    <MedicalDataAdditional
                        icon="fa-pencil-alt"
                        eventKey="6"
                        data={caseRecord}
                        disabled={true}
                        bindSubmitForm={() => {}}
                    />
                </Accordion>
                <Accordion defaultActiveKey="5" className="mt-5">
                    <CaseContext.Provider value={[caseRecord, setCaseRecord]}>
                        <Binnacle
                            icon="fa-pencil-alt"
                            eventKey="5"
                            data={caseRecord}
                            disabledAll={false}
                            hideButton={true}
                            hideReason={false}
                            eventStage="Cancelaciones"
                            {...props}
                        />
                    </CaseContext.Provider>
                </Accordion>
            </BlockCaseContext.Provider>
        </>
    );
};

export default CasesCanceledDetails;

